import { motion } from "motion/react";
import styles from "./login.module.css";

// SVG-шум: feTurbulence + порог по альфа-каналу -> редкие точки,
// а не сплошная дымка. Возвращаем готовый data-URI.
const makeNoise = (svg) =>
  `url("data:image/svg+xml,${encodeURIComponent(svg.trim())}")`;

// редкие белые звёзды на прозрачном фоне (альфа = 1.8*A - 1.2 > 0 редко)
const starsNoise = makeNoise(`
<svg xmlns='http://www.w3.org/2000/svg' width='300' height='300'>
  <filter id='s'>
    <feTurbulence type='fractalNoise' baseFrequency='0.8' numOctaves='4' seed='7' stitchTiles='stitch'/>
    <feColorMatrix type='matrix' values='0 0 0 0 1  0 0 0 0 1  0 0 0 0 1  0 0 0 1.8 -1.2'/>
  </filter>
  <rect width='300' height='300' filter='url(#s)'/>
</svg>`);

// мелкие тёмные песчинки (альфа = 1.6*A - 1.0)
const sandNoise = makeNoise(`
<svg xmlns='http://www.w3.org/2000/svg' width='200' height='200'>
  <filter id='n'>
    <feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3' seed='3' stitchTiles='stitch'/>
    <feColorMatrix type='matrix' values='0 0 0 0 0.902  0 0 0 0 0.835  0 0 0 0 0.722  0 0 0 1.6 -1.0'/>
  </filter>
  <rect width='200' height='200' filter='url(#n)'/>
</svg>`);

export default function SpaceBackground({ expanded }) {
  return (
    <div className={styles.spaceBackground} aria-hidden="true">
      {/* чёрный космос со звёздным шумом */}
      <div
        className={styles.spaceNoise}
        style={{ backgroundImage: starsNoise }}
      />
      {/* планета: шар с радиальным градиентом и песчаным шумом */}
      <motion.div
        className={styles.planet}
        style={{ ["--planet-noise"]: sandNoise }}
        initial={false}
        animate={{ scale: expanded ? 1.4 : 1 }}
        transition={{ duration: 0.45, ease: "easeInOut" }}
      />
    </div>
  );
}
